<script>
import { mapState, mapActions } from 'vuex';
/* components */
import Blur from '@/components/Blur';
/* tools */
import { flags } from '@/scripts/constants/collection';
import { getRandomInt } from '@/scripts/utils';
import SvgIcon from '@/components/SvgIcon';
import { getAsset } from '@/scripts/utils';

export default {
  name: 'Tournaments',
  components: {
    Blur,
    SvgIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: !false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions({}),
    anyPossibleFlag() {
      const places = flags.length - 1;
      const result = `flag-${flags[getRandomInt(places)]}`;

      return result;
    },
    getAsset,
  },
};
</script>

<template>
  <Blur :active="true">
    <template #primary>
      <!-- TODO: remove block -->
      <div
        class="wrapper cover"
        v-show="true"
        :style="
          getAsset('tournaments-default', {
            type: 'png',
            path: 'tournaments',
            style: true,
          })
        "
      ></div>
      <div class="wrapper" v-show="false">
        <div class="round quarter">
          <div v-for="i in 8" :key="i" class="card card__quarter">
            <SvgIcon :name="anyPossibleFlag()"></SvgIcon>
            <span>1/8_{{ i }}_and_long_text</span>
          </div>
        </div>
        <div class="round semi">
          <div v-for="i in 4" :key="i" class="card card__semi">
            <SvgIcon :name="anyPossibleFlag()"></SvgIcon>
            <span>1/4_{{ i }}_and_long_text</span>
          </div>
        </div>
        <div class="round final">
          <div v-for="i in 2" :key="i" class="card card__final">
            <SvgIcon :name="anyPossibleFlag()"></SvgIcon>
            <span>1_{{ i }}_and_long_text</span>
          </div>
        </div>
        <div class="round winner">
          <div class="card card__winner">
            <SvgIcon :name="anyPossibleFlag()"></SvgIcon>
            <span>winner</span>
          </div>
        </div>
      </div>
    </template>
    <template #secondary>
      <div class="overlay">
        <div class="title">Tournaments</div>
        <div class="subtitle">Coming Soon</div>
      </div>
    </template>
  </Blur>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.wrapper {
  display: flex;
  justify-content: space-around;

  .cover {
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.round {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.card {
  width: 200px;
  height: 40px;
  background-color: #1d2429;
}

.overlay {
  margin-top: -265px;
  padding-top: 30px;
}

.title {
  font-family: Sen-Bold;
  font-size: 60px;
  line-height: 72px;
  text-align: center;
  text-transform: uppercase;
  color: #ffc107;

  & + .subtitle {
    margin-top: 15px;
  }
}

.subtitle {
  font-family: Poppins-Medium;
  font-size: 24px;
  line-height: 33px;
  text-align: center;
  text-transform: uppercase;
  color: #ffffff;
}

@media (max-width: $mobile) {
  .title {
    font-size: 24px;
    line-height: 29px;

    & + .subtitle {
      margin-top: 20px;
    }
  }

  .subtitle {
    font-size: 18px;
    line-height: 25px;
  }

  .overlay {
    padding: 0;
    margin: 0;
    position: absolute;
    top: 70px;
    width: 100%;
    margin-bottom: 60px;
  }
}
</style>
